module.exports = __webpack_public_path__ + "media/customizations/wonderlandbyrunway/logo-beb8d4bac5e4f962062677b5a7e9648e.png";